module.exports = __webpack_public_path__ + "static/media/cost.cd552219.svg";